module.exports = __webpack_public_path__ + "img/small-ship-wreck-grass-2.fb807d9c.png";